// External libraries
import styled from 'styled-components';

// Zocdoc libraries
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

const ButtonContainer = styled.div`
    padding-top: 19px;

    ${breakpoint.small} {
        padding-top: 38px;
    }
`;

export { ButtonContainer as default, ButtonContainer as ModalButtonContainer };
